import { Pagination } from "antd";
import DOMPurify from "dompurify";
import { DateTime } from "luxon";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const NotificationItem = ({ notification }) => {
  // Get timestamp in the desired format
  const formattedTime = notification.created_at
    ? DateTime.fromSQL(notification.created_at).toFormat("yyyy-MM-dd HH:mm:ss")
    : DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");

  // Determine status color
  const getStatusColor = (notificationType) => {
    if (
      notificationType.toLowerCase().includes("paused") ||
      notificationType.toLowerCase().includes("error")
    ) {
      return "bg-red-500";
    }
    return "bg-green-500"; // Default color for success
  };

  return (
    <div className="bg-white p-2 rounded-md shadow mb-2">
      <div className="flex items-start">
        {/* Status indicator dot - smaller size */}
        <div
          className={`${getStatusColor(
            notification.type
          )} w-3 h-3 rounded-full mt-2 mr-3 flex-shrink-0`}
        ></div>

        {/* Content */}
        <div className="flex-1">
          {/* Title and time */}
          <div className="flex justify-between items-start mb-2">
            <h3 className="text-sm font-medium text-gray-900">
              {notification.type}
            </h3>
            <span className="text-sm text-gray-500">{formattedTime}</span>
          </div>

          {/* Message with HTML parsing */}
          <p
            className="text-gray-600 text-xs"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                notification.message ||
                  `Restore is Paused because of Error calling an xero api of BankTransactions for your organization Imu Chan Architecture Inc. Akshay Architecture 19 march`
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

const SettingsNotifications = () => {
  const allNotifications = useSelector(
    (state) => state.commonReducer.allNotifications || []
  );

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; // Number of notifications per page

  const notificationsData = allNotifications.length > 0 ? allNotifications : [];

  // Get current notifications based on pagination
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentNotifications = notificationsData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Change page handler
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="overflow-y-auto h-full">
      {/* Notification list */}
      <div>
        {currentNotifications.map((notification) => (
          <NotificationItem key={notification.id} notification={notification} />
        ))}
      </div>

      {/* Pagination */}
      {notificationsData.length > pageSize && (
        <div className="flex justify-end mb-6">
          <Pagination
            current={currentPage}
            onChange={handlePageChange}
            total={notificationsData.length}
            pageSize={pageSize}
            showSizeChanger={true}
          />
        </div>
      )}
    </div>
  );
};

export default SettingsNotifications;
